import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setPushTemplates:(state, data) => {
        state.pushTemplates = data
    }
};
